const resumeSize = {
  width: 816,
  height: 1056,
};

export default resumeSize;
